export const colors = {
    "primary": "#FC444E",
    "white": "white",
}